module.exports = {
  billing: {
    invoiceStatus: require('./billing/invoiceStatus'),
    addressStates: require('./billing/addressStates')
  },
  errors: {
    ptBr: {
      dba: require('./errors/ptBr/dba'),
      sys: require('./errors/ptBr/sys'),
      tra: require('./errors/ptBr/tra'),
      bat: require('./errors/ptBr/bat'),
      bil: require('./errors/ptBr/bil'),
      she: require('./errors/ptBr/she'),
      sta: require('./errors/ptBr/sta'),
      use: require('./errors/ptBr/use'),
      com: require('./errors/ptBr/com'),
      cce: require('./errors/ptBr/cce'),
      pix: require('./errors/ptBr/pix'),
      transferFailedReason: require('./errors/ptBr/transferFailedReason')
    },
    en: {
      dba: require('./errors/en/dba'),
      sys: require('./errors/en/sys'),
      tra: require('./errors/en/tra'),
      bat: require('./errors/en/bat'),
      bil: require('./errors/en/bil'),
      she: require('./errors/en/she'),
      sta: require('./errors/en/sta'),
      use: require('./errors/en/use'),
      com: require('./errors/en/com'),
      cce: require('./errors/en/cce'),
      pix: require('./errors/en/pix')
    }
  },
  languages: require('./languages'),
  personType: require('./personType'),
  transferStatus: require('./transferStatus'),
  destinationBankAccountStatus: require('./destinationBankAccountStatus'),
  caixaOperationType: require('./caixaOperationType'),
  transferReportType: require('./transferReportType'),
  statement: {
    entryType: require('./statement/entryType')
  },
  contacerta: {
    type: require('./contacerta/type'),
    pixType: require('./contacerta/pixType'),
    microDepositValidationStatus: require('./contacerta/microDepositValidationStatus'),
    validationSource: require('./contacerta/validationSource')
  },
  roles: {
    appRoles: require('./roles/appRoles'),
    adminRoles: require('./roles/adminRoles'),
    contaCertaRoles: require('./roles/contaCertaRoles'),
    conciliationRoles: require('./roles/conciliationRoles')
  },
  userActions: require('./userActions'),
  userStatus: require('./userStatus'),
  banks: require('./banks'),
  billingHistoryStatus: require('./billingHistoryStatus'),
  batchStatus: require('./batchStatus'),
  automation: {
    validateTransferStatus: require('./automation/validateTransferStatus'),
    executionTracks: require('./automation/executionTracks'),
    transferPolicy: require('./automation/transferPolicy')
  },
  monthlyReportType: require('./monthlyReportType'),
  accountType: require('./accountType'),
  bankImportFiles: {
    paymentType: require('./bankImportFiles/paymentType'),
    cnab240: {
      paymentMethod: require('./bankImportFiles/cnab240/paymentMethod')
    }
  },
  cpfCnpj: {
    nameType: require('./cpfCnpj/nameType'),
    entityStatus: require('./cpfCnpj/entityStatus')
  },
  eventType: require('./eventType'),
  transfeeraData: require('./transfeeraData'),
  regexes: require('./regexes'),
  billetStatus: require('./billetStatus'),
  billetType: require('./billetType'),
  billetCodeType: require('./billetCodeType'),
  batchType: require('./batchType'),
  companyStatus: require('./companyStatus'),
  batchTransferSearchStatus: require('./batchTransferSearchStatus'),
  applications: require('./applications'),
  integration: {
    services: require('./integration/services')
  },
  infraction: {
    infractionOrigin: require('./infraction/infractionOrigin'),
    infractionStatus: require('./infraction/infractionStatus'),
    infractionTransactionType: require('./infraction/infractionTransactionType'),
    infractionType: require('./infraction/infractionType'),
    refundAnalysisStatus: require('./infraction/refundAnalysisStatus'),
    refundRejectionStatus: require('./infraction/refundRejectionStatus'),
    refundStatus: require('./infraction/refundStatus'),
    refundTransactionType: require('./infraction/refundTransactionType'),
    refundType: require('./infraction/refundType')
  },
  bankStatement: {
    entryType: require('./bankStatement/entryType'),
    paymentType: require('./bankStatement/paymentType')
  },
  conciliation: {
    financialServiceProvider: require('./conciliation/financialServiceProvider'),
    status: require('./conciliation/status')
  },
  billet: require('./billet'),
  paymentType: require('./paymentType'),
  accountSource: require('./accountSource'),
  pix: require('./pix'),
  verificationCodeType: require('./verificationCodeType'),
  defaults: require('./defaults'),
  webhookObjectType: require('./webhookObjectType'),
  transferPaymentMethod: require('./transferPaymentMethod'),
  btg: require('./btg'),
  internal: require('./internal'),
  spreadsheetType: require('./spreadsheetType'),
  metrics: require('./metrics')
};
